import { useEffect, useState } from 'react'
import { Cargando } from '../Cargando'
import TarjetScort from '../hooks/TarjetScort'
import { AuthServices } from '../util/authServices';
import { useNavigate } from 'react-router-dom';

const ScortZone = ({ setUserSession, userSession, toast }) => {

    const navigate = useNavigate();

    const [cargando, setCargando] = useState(false)
    const [stateModalActionScort, setStateModalActionScort] = useState(false)
    const [labelActionScort, setLabelActionScort] = useState('')
    const [actionScort, setActionScort] = useState('')
    const [scortAction, setScortAction] = useState({})
    const [scortObjectList, setScortObjectList] = useState([])

    useEffect(() => {
        cargarScortZone()
    }, [])

    const disponibilizaScortAction = (scortObjet) => {
        setStateModalActionScort(true)
        setActionScort("DISPONIBILIZA")
        setLabelActionScort(scortObjet.disponible ? "Sacar de disponibilidad" : "Disponibilizar")
        setScortAction(scortObjet)
    }

    const confirmaActionScort = () => {
        setStateModalActionScort(false)
        actualizaActionScortService()
    }

    const cancelaActionScort = () => {
        setActionScort("")
        setStateModalActionScort(false)
        setScortAction({})
    }

     const closeSession = () => {
        setUserSession({
            nombre: "",
            apellido: "",
            usuario: "",
            role: "USUARIO_LOGIN"
        })
        sessionStorage.removeItem('userSessionStorage')
        navigate('/adminZone', { replace: true })
    }

    const cargarScortZone = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "usuario": userSession.usuario
            }
            const response = await authServices.requestPost(body, 12);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setScortObjectList(objeto)
            } else {
                toast(mensaje)
            }
            setCargando(false)
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const actualizaActionScortService = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "idProcesamiento": scortAction.idProcesamiento,
                "action": actionScort,
                "dateAction": new Date()
            }
            const response = await authServices.requestPost(body, 11);
            const { mensaje } = response.data;
            cargarScortZone()
            toast(mensaje)
            setCargando(false)
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    return (
        <div className='div-container'>
            <div className="row m-0">
                <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                    <div className='div-name-user'>
                        <p>{`${userSession.nombre} ${userSession.apellido}`}</p>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                    <div className='div-close-info' style={{ height: "3rem" }}>
                        <button className='btn btn-link btn-close-modal' onClick={() => closeSession()} >Cerrar</button>
                    </div>
                </div>
            </div>
            <div className="row m-0">
                {
                    scortObjectList?.map((scortObjet, i) => {
                        return (
                            <>
                                <div key={i} className="col-12 col-sm-2 col-md-3 col-lg-4 div-actions-preliminar-padre" ></div>
                                <div key={i} className="col-12 col-sm-8 col-md-6 col-lg-4 div-actions-preliminar-padre" >
                                    <div className='div-actions-preliminar-actions-padre'>
                                        <div className='div-actions-preliminar-actions'>
                                            <p>Disponible</p>
                                            <div className={scortObjet.disponible ? 'div-container-select-padre-active' : 'div-container-select-padre'} onClick={() => disponibilizaScortAction(scortObjet)} >
                                                <div className={scortObjet.disponible ? 'div-container-select-active' : 'div-container-select'}></div>
                                            </div>
                                        </div>
                                    </div>
                                    <TarjetScort scortObjet={scortObjet} preView='preliminar' />
                                </div>
                                <div key={i} className="col-12 col-sm-2 col-md-3 col-lg-4 div-actions-preliminar-padre" ></div>
                            </>
                        )
                    })
                }
            </div>
            {
                stateModalActionScort ?
                    <div className='div-cargando-active'>
                        <div className='div-gift-element'>
                            <div className='div-modal-elimina-scort'>
                                <div className='mb-4'>
                                    <h3>Acciones Scort</h3>
                                    <br />
                                    <p >Seguro desea
                                        <font className='parrafo-elimina-scort '> {labelActionScort}</font>
                                    </p>
                                </div>
                                <div className='div-butoms-delete-scort'>
                                    <button className='btn btn-link btn-close-modal' onClick={() => confirmaActionScort()} >Aceptar</button>
                                    <button className='btn btn-link btn-close-modal' onClick={() => cancelaActionScort()} >Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
            }
            {
                cargando ?
                    <Cargando />
                    :
                    <></>
            }
        </div>
    )
}

export default ScortZone